module.exports = __webpack_public_path__ + "img/km.136aa917.svg";